import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconWrapper, FILL_COLOR_CLASS_NAMES } from "./IconWrapper";
import classNames from "classnames";
const MinusIcon = (props) => {
    const colorClassName = props.color
        ? FILL_COLOR_CLASS_NAMES[props.color]
        : null;
    return (_jsx(IconWrapper, Object.assign({}, props, { children: _jsxs("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsx("path", Object.assign({ d: "M40 19.857c0 1.188-1.029 2.857-2.308 2.857H2.308C1.034 22.714 0 21.04 0 19.857 0 18.677 1.034 17 2.308 17h35.384C38.972 17 40 18.679 40 19.857Z", fill: "currentColor" }, props, { className: classNames(colorClassName, props.className) })), _jsx("title", { children: props.title })] })) })));
};
export default MinusIcon;
//# sourceMappingURL=MinusIcon.js.map